// extracted by mini-css-extract-plugin
export default {"form":"useBulkNote-m_form-zzrc1mEE","body":"useBulkNote-m_body-d2qzFACg","radios":"useBulkNote-m_radios-Q80kjTfu","preview":"useBulkNote-m_preview-PINeSwjS"};